import React, { PureComponent, Fragment } from 'react';
import { Link } from 'react-router';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

export class LoggedInUserLinks extends PureComponent {
  handleUserLogout = e => {
    e.preventDefault();
    this.props.onClickLogout();
  };

  render() {
    const { canViewUnifiedSearch } = this.props;

    return (
      <Fragment>
        {canViewUnifiedSearch && (
          <li>
            <Link to="/search">
              <FormattedMessage id="header.link.search" defaultMessage="Find a class" />
            </Link>
          </li>
        )}
        <li>
          <a href="/settings/membership">
            <FormattedMessage id="accountDropdown.accountLink" defaultMessage="Settings" />
          </a>
        </li>
        <li>
          <a href="/" onClick={this.handleUserLogout}>
            <FormattedMessage id="accountDropdown.logoutLink" defaultMessage="Log out" />
          </a>
        </li>
      </Fragment>
    );
  }
}

LoggedInUserLinks.propTypes = {
  canViewUnifiedSearch: PropTypes.bool,
  onClickLogout: PropTypes.func.isRequired,
};
